import * as React from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import logo from '../../assets/images/logo.png'
import PhoneInput from 'react-phone-input-2';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GoogleLogin } from '@react-oauth/google';
import { Link } from 'react-router-dom';
import OtpInput from 'react-otp-input';
import OTPInput from 'react-otp-input';
import { useDispatch, useSelector } from 'react-redux';
import * as AuthAction from '../../redux/actions/AuthAction';
import * as CheckoutAction from '../../redux/actions/CheckoutAction';
import AlertMessage from '../common/AlertMessage';
import { bindActionCreators } from 'redux';
import { jwtDecode } from "jwt-decode";
import loginBg from '../../assets/images/login-bg.jpg'
import {
    CitySelect,
    CountrySelect,
    StateSelect,
    LanguageSelect,
} from "react-country-state-city";
import Loading from '../common/Loading';

export default function Login(props) {
    const [open, setOpen] = React.useState(false);
    const [isOpen, setIsOpen] = React.useState(false);
    const [message, setMessage] = React.useState(null);
    const [fullWidth, setFullWidth] = React.useState(true);
    const [form, setForm] = React.useState({})
    const [sendOtp, setSendOtp] = React.useState(false)
    const [profile, setProfile] = React.useState(false)
    const [otp, setOtp] = React.useState('');
    const dispatch = useDispatch()
    const Auth = useSelector((state) => state?.auth?.otpSend)
    const { sendOTPforLogin, verifyOtpforLogin, profileComplete, SocialLogin } = bindActionCreators(AuthAction, dispatch)
    const ip_address = localStorage.getItem('ip_address')
    const [address, setAddress] = React.useState(false)
    const [stateid, setstateid] = React.useState(0);
    const [loader, setLoader] = React.useState(false)
    const { address_create } = bindActionCreators(CheckoutAction, dispatch)

    const handleClose = () => {
        setOpen(false);
        props?.state(false)
    };

    const handleGoogleLogin = async (data) => {
        let GoogleData = jwtDecode(data?.credential)
        console.log(GoogleData)
        if (GoogleData?.email_verified) {
            form.email = GoogleData.email
            form.name = GoogleData.name
            const resData = await SocialLogin(form)
            console.log("Res", resData)
            if (resData?.statuscode == 200) {
                setMessage({ ...message, message: "Logged in successfully", flag: "success" })
                setIsOpen(true)
                form.user_id = resData?.data?.id

                if (resData?.first_time == "true") {
                    setProfile(true)
                    form.flag = "email"

                } else {
                    localStorage.setItem("user", JSON.stringify(resData))
                    localStorage.setItem("login", true)
                    props?.state(false)
                }
            }
            else {
                setMessage({ ...message, message: resData?.message, flag: "error" })
                setIsOpen(true)
            }
        }
    }

    const sendOtpMobile = async (data) => {
        if (form?.email) {
            setLoader(true)
            form.flag = "email"
            const resData = await sendOTPforLogin(form)
            if (resData?.statuscode == 200) {
                setSendOtp(true)
                setMessage({ ...message, message: resData?.message, flag: "success" })
                // setOtp(resData?.OTP)
                setIsOpen(true)
                setLoader(false)


            }
            else {
                setMessage({ ...message, message: resData?.message, flag: "error" })
                setIsOpen(true)
                setLoader(false)

            }

        }
        else {
            setMessage({ ...message, message: "Enter email address", flag: "error" })
            setIsOpen(true)

        }

    }
    const verifyOTP = async (data) => {
        const resData = await verifyOtpforLogin({ ...form, OTP: otp })
        if (resData?.statuscode == 200) {
            form.user_id = resData?.data?.id
            if (resData?.first_time == "true") {
                setProfile(true)
            }
            else {
                setForm({})
                localStorage.setItem("user", JSON.stringify(resData))
                localStorage.setItem("login", true)
                props?.state(false)
            }
            setMessage({ ...message, message: resData?.message, flag: "success" })
            setIsOpen(true)
        }
        else {
            setMessage({ ...message, message: resData?.message, flag: "error" })
            setIsOpen(true)
        }
    }


    const validateForm = () => {
        let errors = {};

        // Full Name Validation
        if (!form?.name || form?.name.trim().length < 3) {
            errors.name = "Full Name must be at least 3 characters";
        }

        // ABN Number Validation (11 digits only)
        if (!form?.abn_number || !/^\d{11}$/.test(form?.abn_number)) {
            errors.abn_number = "ABN Number must be exactly 11 digits";
        }

        // Mobile Validation
        if (!form?.mobile_number) {
            errors.mobile_number = "Mobile number is required";
        }
        //  else if (!/^(\+61|0)4\d{8}$/.test(form?.mobile_number)) {
        //     errors.mobile_number = "Enter a valid Australian mobile (e.g. 04XXXXXXXX or +614XXXXXXXX)";
        // }

        return errors;
    };


    const handleSubmit = async (e) => {
        e.preventDefault()

        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            setMessage({ ...message, message: Object.values(errors).join(", "), flag: "error" });
            setIsOpen(true);
            return;
        }




        form.ip_address = ip_address

        const formlist = new FormData()
        Object.keys(form).map((key) => formlist.append(key, form?.[key]));

        const resData = await profileComplete(formlist)
        console.log("Response", resData)
        if (resData?.statuscode == 200) {
            localStorage.setItem("user", JSON.stringify(resData))
            localStorage.setItem("login", true)
            setMessage({ ...message, message: resData?.message, flag: "success" })
            setIsOpen(true)
            props?.state(false)
            setProfile(false)
            setForm({})

            setSendOtp(false)
            // setAddress(true)
        } else {
            setMessage({ ...message, message: resData?.message, flag: "error" })
            setIsOpen(true)

        }

    }



    const saveAddressFn = async (e) => {
        e.preventDefault()
        const user = JSON.parse(localStorage.getItem('user'))
        const resData = await address_create({ ...form, user_id: user?.data?.id })
        console.log("res", resData)
        if (resData?.statuscode == 200) {
            setForm({})
            setIsOpen(true)
            setMessage({ ...message, message: resData?.message, flag: "success" })
            props?.state(false)
        }
        else {
            setIsOpen(true)
            setMessage({ ...message, message: resData?.message, flag: "error" })
        }
    }

    const handleABNChange = (e) => {
        let value = e.target.value.replace(/\D/g, ""); // remove non-digits
        if (value.length > 11) value = value.slice(0, 11); // limit to 11 digits
        setForm({ ...form, abn_number: value });
    };



    return (
        <React.Fragment>

            <AlertMessage open={isOpen} message={message} state={setIsOpen} />
            <Dialog
                fullWidth={fullWidth}
                maxWidth={'md'}
                open={props?.open}
                // onClose={handleClose}
                sx={{
                    backdropFilter: "blur(10px)"
                }}
            >
                <Loading open={loader} setOpen={setLoader} />

                <div className='d-flex align-items-center '>
                    <div className='flex-manage hide-responsive-login'>
                        <img src={loginBg} alt='login' className='w-100' />
                    </div>
                    <div className='flex-manage'>
                        <DialogTitle style={{ padding: "0" }}>
                            <div className='d-flex justify-content-center'>
                                <img src={logo} alt='logo' style={{ width: "150px" }} />
                            </div>
                        </DialogTitle>
                        <DialogContent>
                            {
                                !sendOtp && !profile &&
                                <div>
                                    <DialogContentText className='text-center'>
                                        Login for quality you can trust, harvest you can enjoy!
                                    </DialogContentText>
                                    <Box
                                        noValidate
                                        component="form"
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            m: 'auto',
                                            width: 'fit-content',
                                            // height: "35vh"
                                        }}
                                        className='py-0'
                                    >
                                        <div className='w-100 mt-30'>
                                            {/* <PhoneInput
                                        labelId="demo-simple-select-label"
                                        country={'au'}
                                        required={true}
                                        // value={form?.phoneNumber}

                                        onChange={(phone, countryCode) => {
                                            setForm({
                                                ...form,
                                                mobile_number:
                                                    (countryCode.dialCode == "91" ? (phone[2] >= 6 ? phone.substring(2) : countryCode.dialCode)
                                                        : phone.substring(2)),
                                                countryCode: "+" + countryCode.dialCode,
                                            });
                                            console.log(form)
                                        }}
                                        isValid={(value, country) => {
                                            if (country.dialCode == "91" && value[2] < 6) {
                                                return 'Invalid Number'
                                            } else {
                                                return true;
                                            }
                                        }}
                                        inputStyle={{
                                            height: '45px',
                                            width: "99.99%"
                                        }}

                                    /> */}
                                            <label
                                                htmlFor="email"
                                                className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                                            >
                                                Email Address{" "}
                                                <span className="text-danger text-xl line-height-1">*</span>{" "}
                                            </label>
                                            <input
                                                onChange={(e) => setForm({ ...form, email: e.target.value })}
                                                type="email"
                                                className="common-input px-16 w-100"
                                                id="email"
                                                placeholder="example@mail.com"
                                                required
                                            />
                                        </div>
                                        {/* <div>
                                            <span className='py-10 d-flex' style={{ justifyContent: "center" }}>or</span>
                                        </div> */}
                                        {/* <div style={{ display: "flex", justifyContent: "center" }}>
                                            <GoogleOAuthProvider clientId="846756764119-91p1ls3cem6e7jtc6t3cpmgb54vd1751.apps.googleusercontent.com">
                                                <GoogleLogin
                                                    auto_select={false}
                                                    width={250}
                                                    theme="outline"
                                                    onSuccess={credentialResponse => {
                                                        // console.log(credentialResponse)
                                                        handleGoogleLogin(credentialResponse)
                                                    }}
                                                    onError={() => {
                                                        console.log('Login Failed')
                                                    }}
                                                    useOneTap
                                                />
                                            </GoogleOAuthProvider>
                                        </div> */}

                                    </Box>
                                </div>
                            }
                            {
                                sendOtp && !profile &&
                                <div>
                                    <DialogContentText>
                                        Please enter the OTP sent to your registered email to proceed.
                                    </DialogContentText>
                                    <Box
                                        noValidate
                                        component="form"
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            m: 'auto',
                                            width: 'fit-content',
                                            // height: "35vh"
                                        }}
                                        className='py-20'
                                    >
                                        <OTPInput
                                            value={otp}
                                            onChange={setOtp}
                                            numInputs={4}
                                            renderSeparator={<span>  -  </span>}
                                            renderInput={(props) => <input {...props} />}
                                            inputStyle={{
                                                height: "45px",
                                                width: "45px",
                                                borderRadius: "10px",
                                                border: "2px solid black"
                                            }}
                                        />
                                    </Box>
                                </div>
                            }
                            {
                                profile && !address &&
                                <div>
                                    {
                                        form?.flag !== "email" ?
                                            <div>
                                                <form onSubmit={handleSubmit}>
                                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                                        <div className="col-sm-8 col-xs-8">
                                                            <label
                                                                htmlFor="name"
                                                                className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                                                            >
                                                                Full Name{" "}
                                                                <span className="text-danger text-xl line-height-1">*</span>{" "}
                                                            </label>
                                                            <input
                                                                onChange={(e) => setForm({ ...form, name: e.target.value })}
                                                                required
                                                                value={form?.name}
                                                                type="text"
                                                                className="common-input px-16"
                                                                id="name"
                                                                placeholder="Full name"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='py-10' style={{ display: "flex", justifyContent: "center" }}>
                                                        <div className="col-sm-8 col-xs-8">
                                                            <label
                                                                htmlFor="name"
                                                                className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                                                            >
                                                                ABN Number{" "}
                                                                <span className="text-danger text-xl line-height-1">*</span>{" "}
                                                            </label>
                                                            <input
                                                                onChange={handleABNChange}
                                                                required
                                                                value={form?.abn_number}
                                                                type="text"
                                                                inputMode="numeric"
                                                                pattern="\d{11}"
                                                                maxLength={11}
                                                                className="common-input px-16"
                                                                id="abn"
                                                                placeholder="Enter 11-digit ABN Number"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='py-10' style={{ display: "flex", justifyContent: "center" }}>

                                                        <div className="col-sm-8 col-xs-8">
                                                            <label
                                                                htmlFor="email"
                                                                className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                                                            >
                                                                Email Address{" "}
                                                                <span className="text-danger text-xl line-height-1">*</span>{" "}
                                                            </label>
                                                            <input
                                                                onChange={(e) => setForm({ ...form, email: e.target.value })}
                                                                type="email"
                                                                className="common-input px-16"
                                                                id="email"
                                                                placeholder="Email address"
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='py-10' style={{ display: "flex", justifyContent: "center" }}>
                                                        <button type='submit' className="btn btn-main d-inline-flex align-items-center rounded-pill gap-8">
                                                            Submit
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                            :
                                            <form onSubmit={handleSubmit}>
                                                <div>
                                                    <div style={{ display: "flex", justifyContent: "center" }}>

                                                        <div className="col-sm-8 col-xs-8">
                                                            <label
                                                                htmlFor="name"
                                                                className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                                                            >
                                                                Full Name{" "}
                                                                <span className="text-danger text-xl line-height-1">*</span>{" "}
                                                            </label>
                                                            <input
                                                                onChange={(e) => setForm({ ...form, name: e.target.value })}
                                                                value={form?.name}
                                                                type="text"
                                                                className="common-input px-16"
                                                                id="name"
                                                                required
                                                                placeholder="Full name"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='py-10' style={{ display: "flex", justifyContent: "center" }}>
                                                        <div className="col-sm-8 col-xs-8">
                                                            <label
                                                                htmlFor="name"
                                                                className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                                                            >
                                                                ABN Number{" "}
                                                                <span className="text-danger text-xl line-height-1">*</span>{" "}
                                                            </label>
                                                            <input
                                                                onChange={handleABNChange}
                                                                required
                                                                value={form?.abn_number}
                                                                type="text"
                                                                inputMode="numeric"
                                                                pattern="\d{11}"
                                                                maxLength={11}
                                                                className="common-input px-16"
                                                                id="abn"
                                                                placeholder="Enter 11-digit ABN Number"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div style={{ display: "flex", justifyContent: "center" }}>

                                                        <div className="col-sm-8 col-xs-8">

                                                            <label
                                                                htmlFor="email"
                                                                className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                                                            >
                                                                Mobile{" "}
                                                                <span className="text-danger text-xl line-height-1">*</span>{" "}
                                                            </label>
                                                            <PhoneInput
                                                                labelId="demo-simple-select-label"
                                                                country={'au'}
                                                                required={true}
                                                                // value={form?.phoneNumber}

                                                                onChange={(phone, countryCode) => {
                                                                    setForm({
                                                                        ...form,
                                                                        mobile_number:
                                                                            (countryCode.dialCode == "91" ? (phone[2] >= 6 ? phone.substring(2) : countryCode.dialCode)
                                                                                : phone.substring(2)),
                                                                        countryCode: "+" + countryCode.dialCode,
                                                                    });
                                                                    console.log(form)
                                                                }}
                                                                isValid={(value, country) => {
                                                                    if (country.dialCode == "91" && value[2] < 6) {
                                                                        return 'Invalid Number'
                                                                    } else {
                                                                        return true;
                                                                    }
                                                                }}
                                                                inputStyle={{
                                                                    height: '55px',
                                                                    width: "99.99%"
                                                                }}

                                                            />
                                                        </div>

                                                    </div>
                                                    <div className='py-20' style={{ display: "flex", justifyContent: "center" }}>
                                                        <button onSubmit={handleSubmit} type='submit' className="btn btn-main d-inline-flex align-items-center rounded-pill gap-8">
                                                            Submit
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                    }

                                </div>
                            }

                            {
                                address && profile &&
                                <form onSubmit={saveAddressFn} className='row'>
                                    <div className="col-sm-12 col-xs-12">
                                        <label
                                            htmlFor="name"
                                            className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                                        >
                                            Address Type{" "}
                                            <span className="text-danger text-xl line-height-1">*</span>{" "}
                                        </label>
                                        <div className="form-check common-check common-radio">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="color"
                                                required
                                                id="brand1"
                                                checked={form?.address_type == "office" ? true : false}
                                                onClick={(e) => setForm({ ...form, address_type: "office" })}
                                            />
                                            <label className="form-check-label" htmlFor="brand1">
                                                Office
                                            </label>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="color"
                                                id="brand2"
                                                required
                                                checked={form?.address_type == "home" ? true : false}
                                                onClick={(e) => setForm({ ...form, address_type: "home" })}

                                            />
                                            <label className="form-check-label" htmlFor="brand2">
                                                Home
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-xs-6 mt-10">
                                        <label
                                            htmlFor="name"
                                            className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                                        >
                                            House No.{" "}
                                            <span className="text-danger text-xl line-height-1">*</span>{" "}
                                        </label>
                                        <input
                                            type="text"
                                            className="common-input px-16"
                                            placeholder=""
                                            required
                                            value={form?.house_no}
                                            onChange={(e) => setForm({ ...form, house_no: e.target.value })}

                                        />
                                    </div>
                                    <div className="col-sm-6 col-xs-6 mt-10">
                                        <label
                                            htmlFor="name"
                                            className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                                        >
                                            Tenament Name / Apartment.{" "}
                                            <span className="text-danger text-xl line-height-1">*</span>{" "}
                                        </label>
                                        <input
                                            type="text"
                                            className="common-input px-16"
                                            placeholder=""
                                            required
                                            value={form?.house_name}
                                            onChange={(e) => setForm({ ...form, house_name: e.target.value })}

                                        />
                                    </div>
                                    <div className="col-sm-6 col-xs-6 mt-10">
                                        <label
                                            htmlFor="name"
                                            className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                                        >
                                            Street
                                            <span className="text-danger text-xl line-height-1">*</span>{" "}
                                        </label>
                                        <input
                                            type="text"
                                            className="common-input px-16"
                                            required
                                            placeholder=""
                                            value={form?.street_road}

                                            onChange={(e) => setForm({ ...form, street_road: e.target.value })}

                                        />
                                    </div>
                                    <div className="col-sm-6 col-xs-6 mt-10">
                                        <label
                                            htmlFor="name"
                                            className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                                        >
                                            Landmark
                                            <span className="text-danger text-xl line-height-1">*</span>{" "}
                                        </label>
                                        <input
                                            type="text"
                                            className="common-input px-16"
                                            placeholder=""

                                            value={form?.landmark}

                                            onChange={(e) => setForm({ ...form, landmark: e.target.value })}

                                        />
                                    </div>
                                    <div className="col-sm-6 col-xs-6 mt-10">
                                        <label
                                            htmlFor="name"
                                            className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                                        >
                                            Area
                                            <span className="text-danger text-xl line-height-1">*</span>{" "}
                                        </label>
                                        <input
                                            type="text"
                                            className="common-input px-16"
                                            placeholder=""
                                            required
                                            value={form?.area}

                                            onChange={(e) => setForm({ ...form, area: e.target.value })}

                                        />
                                    </div>

                                    <div className="col-sm-6 col-xs-6 mt-10">
                                        <label
                                            htmlFor="name"
                                            className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                                        >
                                            State
                                            <span className="text-danger text-xl line-height-1">*</span>{" "}
                                        </label>
                                        {/* <input
                                                        type="text"
                                                        className="common-input px-16"
                                                        placeholder=""
                                                        required
                                                        value={form?.state}
                                                        onChange={(e) => setForm({ ...form, state: e.target.value })}

                                                    /> */}

                                        <StateSelect
                                            countryid={14}
                                            onChange={(e) => {
                                                setstateid(e.id);
                                                setForm({ ...form, state: e.name })
                                            }}
                                            placeHolder="Select State"
                                        />
                                    </div>
                                    <div className="col-sm-6 col-xs-6 mt-10">
                                        <label
                                            htmlFor="name"
                                            className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                                        >
                                            City
                                            <span className="text-danger text-xl line-height-1">*</span>{" "}
                                        </label>
                                        <CitySelect
                                            countryid={14}
                                            stateid={stateid}
                                            onChange={(e) => {
                                                console.log(e);
                                                setForm({ ...form, city: e.name })

                                            }}
                                            placeHolder="Select City"
                                        />
                                    </div>
                                    <div className="col-sm-6 col-xs-6 mt-10">
                                        <label
                                            htmlFor="name"
                                            className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
                                        >
                                            Pincode
                                            <span className="text-danger text-xl line-height-1">*</span>{" "}
                                        </label>
                                        <input
                                            type="number"
                                            className="common-input px-16"
                                            placeholder=""
                                            required
                                            value={form?.pincode}
                                            onChange={(e) => setForm({ ...form, pincode: e.target.value })}

                                        />
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>

                                        <button
                                            type="submit"
                                            className="btn btn-main  py-18 mt-10 rounded-8 "

                                        >
                                            Save
                                        </button>
                                    </div>
                                </form>
                            }

                        </DialogContent>
                        <DialogActions sx={{ display: "flex", justifyContent: sendOtp ? "space-evenly" : "center" }}>
                            {
                                sendOtp && !profile &&
                                <div
                                    to="#"
                                    className="d-flex"
                                    style={{ alignItems: "center", cursor: "pointer" }}
                                    onClick={() => setSendOtp(false)}
                                >
                                    <span className="icon text-xl d-flex">
                                        <i className="ph ph-arrow-left" />{" "}
                                    </span>
                                    {" "}Back

                                </div>
                            }
                            {
                                !profile &&
                                <div
                                    to="#"
                                    className="btn btn-main d-inline-flex align-items-center rounded-pill-x gap-8"
                                    onClick={!sendOtp ? sendOtpMobile : verifyOTP}
                                >
                                    Next{" "}
                                    <span className="icon text-xl d-flex">
                                        <i className="ph ph-arrow-right" />{" "}
                                    </span>
                                </div>
                            }

                        </DialogActions>
                    </div>
                </div>
            </Dialog>
        </React.Fragment>)
}
